// Utility functions for status mapping and formatting

/**
 * Maps frontend status values to backend API expected values
 */
export const mapStatusToAPI = (frontendStatus: string): string => {
  const statusMapping: { [key: string]: string } = {
    'todo': 'To_Do',
    'inProgress': 'In_Progress', 
    'passed': 'Passed',
    'failed': 'Failed'
  };
  
  return statusMapping[frontendStatus] || frontendStatus;
};

/**
 * Maps backend API status values to frontend display values
 */
export const mapStatusFromAPI = (apiStatus: string): string => {
  const statusMapping: { [key: string]: string } = {
    'To_Do': 'todo',
    'In_Progress': 'inProgress',
    'Passed': 'passed',
    'Failed': 'failed'
  };
  
  return statusMapping[apiStatus] || apiStatus.toLowerCase();
};

/**
 * Formats status for display (converts camelCase to readable format)
 */
export const formatStatusForDisplay = (status: string): string => {
  return status.replace(/([A-Z])/g, ' $1').toLowerCase();
};

/**
 * Validates if a status is a valid frontend status
 */
export const isValidFrontendStatus = (status: string): boolean => {
  return ['todo', 'inProgress', 'passed', 'failed'].includes(status);
};

/**
 * Validates if a status is a valid backend API status
 */
export const isValidAPIStatus = (status: string): boolean => {
  return ['To_Do', 'In_Progress', 'Passed', 'Failed'].includes(status);
};
